import { render, staticRenderFns } from "./sampleDynamics.vue?vue&type=template&id=14b67460&scoped=true"
import script from "./sampleDynamics.vue?vue&type=script&lang=js"
export * from "./sampleDynamics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b67460",
  null
  
)

export default component.exports